function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import React, { memo, useCallback, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';
import { DayPickerRangeController } from 'react-dates';
import { START_DATE, END_DATE } from 'react-dates/constants';
import isSameDay from 'react-dates/lib/utils/isSameDay';
import isAfterDay from 'react-dates/lib/utils/isAfterDay';
import isBeforeDay from 'react-dates/lib/utils/isBeforeDay';
import omit from 'lodash/omit';
import renderIf from '@signal/utils/renderIf';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import { usePopupState, bindToggle, bindPopper } from 'material-ui-popup-state/hooks';
import Button from '../Button';
import ButtonToggle from '../ButtonToggle';
import Typography from '../Typography';
import { Popper, NavPrevIcon, NavNextIcon, ButtonCalendarIcon, ButtonTypography, DateInput, DatePickerWrapper, PresetWrapper, InputWrapper } from './styles';
import { FUTURE_DATES, PAST_DATES } from './constants';
export * from './constants';
export var datePickerPresetPropType = PropTypes.arrayOf(PropTypes.shape({
  text: PropTypes.string,
  start: momentPropTypes.momentObj,
  end: momentPropTypes.momentObj
}));
export var DatePickerControls = /*#__PURE__*/memo(function DatePickerControls(props) {
  var disabled = props.disabled,
      startDate = props.startDate,
      startDateStr = props.startDateStr,
      endDate = props.endDate,
      endDateStr = props.endDateStr,
      onFocusChange = props.onFocusChange,
      onPresetClick = props.onPresetClick,
      presets = props.presets;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderIf(presets.length, function () {
    return /*#__PURE__*/React.createElement(PresetWrapper, null, presets.map(function (_ref) {
      var text = _ref.text,
          start = _ref.start,
          end = _ref.end;
      var isSelected = isSameDay(start, startDate) && isSameDay(end, endDate);
      return /*#__PURE__*/React.createElement(Button, {
        key: text,
        variant: "outlined",
        size: "small",
        disabled: disabled || isSelected,
        onClick: function onClick() {
          return onPresetClick(start, end);
        }
      }, text);
    }));
  }), /*#__PURE__*/React.createElement(InputWrapper, null, /*#__PURE__*/React.createElement(DateInput, {
    label: "From",
    disabled: disabled,
    value: startDateStr,
    onFocus: function onFocus() {
      return onFocusChange(START_DATE);
    }
  }), /*#__PURE__*/React.createElement(DateInput, {
    label: "To",
    disabled: disabled,
    value: endDateStr,
    onFocus: function onFocus() {
      return onFocusChange(END_DATE);
    }
  })));
});
export var DatePicker = /*#__PURE__*/memo(function DatePicker(props) {
  var startDate = props.startDate,
      endDate = props.endDate,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      disabledDates = props.disabledDates,
      _props$dayFormat = props.dayFormat,
      dayFormat = _props$dayFormat === void 0 ? 'MM/DD/YYYY' : _props$dayFormat,
      _props$monthFormat = props.monthFormat,
      monthFormat = _props$monthFormat === void 0 ? 'MMMM YYYY' : _props$monthFormat,
      _props$presets = props.presets,
      presets = _props$presets === void 0 ? [] : _props$presets,
      onDatesChange = props.onDatesChange,
      _props$hideToggle = props.hideToggle,
      hideToggle = _props$hideToggle === void 0 ? false : _props$hideToggle;
  var buttonEl = useRef(null);

  var _useState = useState(START_DATE),
      _useState2 = _slicedToArray(_useState, 2),
      focusedInput = _useState2[0],
      setFocusedInput = _useState2[1];

  var onFocusChange = useCallback(function (focus) {
    setFocusedInput(!focus ? START_DATE : focus);
  }, []);
  var getFormattedDay = useCallback(function (day) {
    return day ? day.format(dayFormat) : '';
  }, [dayFormat]);

  var _useMemo = useMemo(function () {
    return [getFormattedDay(startDate), getFormattedDay(endDate)];
  }, [endDate, getFormattedDay, startDate]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      startDateStr = _useMemo2[0],
      endDateStr = _useMemo2[1];

  var isOutsideRange = useMemo(function () {
    switch (disabledDates) {
      case FUTURE_DATES:
        // disallow selection of future dates
        return function (day) {
          return isAfterDay(day, moment());
        };

      case PAST_DATES:
        // disallow selection of past dates
        return function (day) {
          return isBeforeDay(day, moment());
        };

      default:
        return undefined;
    }
  }, [disabledDates]);
  var popupState = usePopupState({
    variant: 'popper',
    popupId: 'date-picker'
  });
  var onPresetClick = useCallback(function (start, end) {
    onDatesChange({
      startDate: start,
      endDate: end
    });
    popupState.close();
    onFocusChange(START_DATE);
  }, [onDatesChange, popupState, onFocusChange]);
  var renderMonthText = useCallback(function (month) {
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, month.format(monthFormat));
  }, [monthFormat]);
  var datePickerProps = omit(props, ['dayFormat', 'hideToggle', 'presets', 'disabledDates', 'buttonProps', 'comparisonPeriod', 'setComparisonPeriod']);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonToggle, Object.assign({}, bindToggle(popupState), {
    buttonRef: buttonEl,
    variant: "outlined",
    disabled: disabled,
    hideToggle: hideToggle,
    open: popupState.isOpen
  }, props.buttonProps), /*#__PURE__*/React.createElement(ButtonCalendarIcon, null), /*#__PURE__*/React.createElement(ButtonTypography, {
    disabled: disabled
  }, startDateStr, "-", endDateStr)), /*#__PURE__*/React.createElement(Popper, Object.assign({}, bindPopper(popupState), {
    anchorEl: buttonEl.current,
    placement: "bottom-end",
    modifiers: {
      flip: {
        enabled: true
      },
      preventOverflow: {
        enabled: true,
        boundariesElement: 'viewport'
      }
    },
    transition: true
  }), function (_ref2) {
    var TransitionProps = _ref2.TransitionProps;
    return /*#__PURE__*/React.createElement(Grow, Object.assign({
      style: {
        transformOrigin: 'top right'
      }
    }, TransitionProps), /*#__PURE__*/React.createElement(Paper, {
      elevation: 2
    }, /*#__PURE__*/React.createElement(ClickAwayListener, {
      onClickAway: popupState.close
    }, /*#__PURE__*/React.createElement(DatePickerWrapper, null, /*#__PURE__*/React.createElement(DayPickerRangeController, Object.assign({
      calendarInfoPosition: "top",
      daySize: 55,
      focusedInput: focusedInput,
      hideKeyboardShortcutsPanel: true,
      horizontalMonthPadding: 0,
      initialVisibleMonth: function initialVisibleMonth() {
        return moment();
      },
      navNext: /*#__PURE__*/React.createElement(NavNextIcon, null),
      navPrev: /*#__PURE__*/React.createElement(NavPrevIcon, null),
      noBorder: true,
      numberOfMonths: 1,
      isOutsideRange: isOutsideRange,
      onFocusChange: onFocusChange,
      renderCalendarInfo: function renderCalendarInfo() {
        return /*#__PURE__*/React.createElement(DatePickerControls, {
          startDate: startDate,
          startDateStr: startDateStr,
          endDate: endDate,
          endDateStr: endDateStr,
          disabled: disabled,
          onFocusChange: onFocusChange,
          onPresetClick: onPresetClick,
          presets: presets
        });
      },
      renderMonthText: renderMonthText
    }, datePickerProps))))));
  }));
});
DatePicker.propTypes = {
  disabled: PropTypes.bool,
  hideToggle: PropTypes.bool,
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
  onDatesChange: PropTypes.func.isRequired,
  presets: datePickerPresetPropType,
  dayFormat: PropTypes.string,
  monthFormat: PropTypes.string,
  disabledDates: PropTypes.oneOf([FUTURE_DATES, PAST_DATES])
};
export default DatePicker;